import { observer } from 'mobx-react';
import { Component, ReactNode } from 'react';
import { IAllBranchesModalItem } from '../../AllBranchesModal';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { branchStore } from 'src/mobx/branchStore';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import { getTranslate, getUnavailable } from 'src/utils/helpers';
import Icon from 'src/view/components/Controls/Icon/Icon';
import Spinner from 'src/view/components/Controls/Spinner/Spinner';

interface IProps {
  selectedBranches: IAllBranchesModalItem[];
  isMulti: boolean;
  clickSave: (branches: IAllBranchesModalItem[]) => void;
  //
  headerTitle?: string;
  className?: string;
  titleClassName?: string;
  iconSize?: number;
  children?: ReactNode;
}

interface IState {
  placeholder: string;
  isAll: boolean;
}

@observer
export default class AllBranchesModalOpen extends Component<IProps, IState> {
  static defaultProps = {
    selectedBranches: [],
    isMulti: false,
  };
  // already selected unavailable
  selectedUnavailable: IAllBranchesModalItem[] = this.props.selectedBranches.filter((branch) => getUnavailable(branch));
  state = {
    placeholder: localeStore.t('branches'),
    isAll: this.props.selectedBranches.length === 0 && this.props.isMulti,
  };

  componentDidMount = () => {
    this.changePlaceholder(this.props.selectedBranches);
  };

  changePlaceholder = (branches: IAllBranchesModalItem[] = []) => {
    const length: number = branches.length - this.selectedUnavailable.length;
    if (this.state.isAll && this.props.isMulti) {
      this.setState({ placeholder: `${localeStore.t('all')} ${localeStore.t('selected')}` });
    } else if (length !== 0) {
      if (length === 1) {
        this.setState({ placeholder: getTranslate(branches[0].name) });
      } else {
        this.setState({ placeholder: `${length} ${localeStore.t('selected')}` });
      }
    } else {
      this.setState({ placeholder: localeStore.t('branches') });
    }
  };

  onSave = (branches: IAllBranchesModalItem[]) => {
    this.props.clickSave(branches);
    this.setState({ isAll: branches.length === 0 && this.props.isMulti }, () => this.changePlaceholder(branches));
    modalStore.closeAllBranchesModal();
  };

  onSubmit = () => {
    modalStore.openAllBranchesModal({
      selectedBranches: this.props.selectedBranches,
      selectedUnavailable: this.selectedUnavailable,
      isMulti: this.props.isMulti,
      isAll: this.state.isAll,
      onSave: this.onSave,
      headerTitle: this.props.headerTitle,
    });
  };

  render() {
    return (
      <div className={`custom-modal__open ${this.props.className || ''}`} onClick={this.onSubmit}>
        {this.props.children ? (
          this.props.children
        ) : (
          <>
            <p className={`family-medium text-size-16 color-dark ${this.props.titleClassName || ''}`}>{this.state.placeholder}</p>
            {branchStore.branches.length < 1 ? (
              <Spinner color={theme.colors.gray} />
            ) : (
              <Icon name={Icons.Chevron} size={this.props.iconSize || 20} className="color-gray2" />
            )}
          </>
        )}
      </div>
    );
  }
}
